import { connect } from 'react-redux';
import { compose, mapProps, withProps } from 'recompose';

import { termsByIds } from '../../../entities/Term/selectors';
import { Endpoints } from '../../../lib/LeanLinkService';
import withPagination from '../../PaginatedItems/withPagination';
import debounceProp from '../../../lib/debounceProp';
import RichSelect from '../RichSelect/RichSelect';
import { withTranslation } from 'react-i18next';

const entityToValue = term => ({
  value: term.id,
  label: term.name,
});

const withTerms = connect((state, { ids }) => (
  {
    options: termsByIds(state, ids),
  }
));

export default compose(
  withTranslation(),
  mapProps(
    props => ({
      ...props,
      placeholder: props.t('Välj villkor'),
      url: Endpoints.terms.list(),
    }),
  ),
  debounceProp('url'),
  withPagination(),
  withTerms,
  withProps(({ options }) => ({
    options: options.map(entityToValue),
  })),
)(RichSelect);
